import React from 'react'
import Main from './Main'

const Register = () => {
  return <Main />
}

export default Register
